import {Box} from "@mui/system";
import CustomFieldSetting from "../CustomFieldUtils/CustomFieldSetting";
import styles from "../../../organizationMainStyles";

export default function ZendeskSettingContainer({msgDataSource, mode}) {

    return(
        <Box sx={styles.heading}>
            <Box sx={style.detailsContainer}>
                <Box sx={style.settingHeader}>
                    {msgDataSource?.name}
                </Box>
                <Box sx={style.settingContainer}>
                    <CustomFieldSetting
                        msgDataSource={msgDataSource}
                        mode={mode}
                    />
                </Box>
            </Box>
        </Box>
    )
}

const style = {
    detailsContainer: {
        border: '1px solid #b6bebf',
        borderRadius: '10px',
        overflow: 'hidden',
        mb: '16px',
    },
    settingContainer: {
        p: '15px',
    },
    settingHeader: {
        borderBottom: '1px solid #b6bebf',
        p: '15px',
    }
}